import React, { useContext, useState } from 'react';
import { Card, HoverCard, Image, Text, Indicator, Box } from '@mantine/core';
import UiStateContext from '../../providers/UiStateProvider';

const InfoCard = ({ type, image, title, info, children }) => {
  const { infoCardOpened, setInfoCardOpened } = useContext(UiStateContext)

  return (
    <HoverCard onOpen={() => setInfoCardOpened([...infoCardOpened, type])} width="25%" shadow="md">
      <HoverCard.Target>
        <Box>
        <Indicator
          size={10}
          color="red"
          style={{ position: 'absolute', top: -5, right: -5 }}
          disabled={infoCardOpened.includes(type)}
        />
          {children}
        </Box>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Card shadow="none" padding="lg" radius="md" withBorder={false}>
          <Card.Section>
            {image && <Image
              src={image}
            />}
          </Card.Section>
          <Text fw={500}>{title}</Text>
          <Text size="sm" c="dimmed">{info}</Text>
        </Card>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

export default InfoCard;
